"use strict";

module.exports = require("./_iterate")("forEach");



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/object/for-each.js
// module id = ../../../node_modules/es5-ext/object/for-each.js
// module chunks = 1